import { createParamRedirect } from 'shared/utils/createParamRedirect'

export const legacyRedirects = [
  {
    oldPath: '/set-password/*',
    component: createParamRedirect('/set-password', { '*': 'token' })
  },
  {
    oldPath: '/reset-password/*',
    component: createParamRedirect('/forgot-password', { '*': 'token' })
  },
  {
    oldPath: '/activate/*',
    component: createParamRedirect('/activate', { '*': 'token' })
  }
]
